import type { AddressControlMode } from '@shared/api/contracts';

export const CONTROL_MODES: AddressControlMode[] = [
  'normal',
  'disabled',
  'blocked',
  'receive_only',
  'withdraw_only',
];

export const CONTROL_MODE_LABEL_KEYS: Record<AddressControlMode, string> = {
  normal: 'wallets.controlMode.normal',
  disabled: 'wallets.controlMode.disabled',
  blocked: 'wallets.controlMode.blocked',
  receive_only: 'wallets.controlMode.receive_only',
  withdraw_only: 'wallets.controlMode.withdraw_only',
};

export const isControlReasonRequired = (mode: AddressControlMode): boolean =>
  mode === 'disabled' || mode === 'blocked';

export const MAX_CONTROL_REASON_LENGTH = 1000;

export const validateControlModeForm = (
  mode: AddressControlMode,
  reason: string,
): string | null => {
  if (!isControlReasonRequired(mode)) {
    return null;
  }

  const trimmed = reason.trim();
  if (!trimmed) {
    return 'required';
  }

  if (trimmed.length > MAX_CONTROL_REASON_LENGTH) {
    return 'maxLength';
  }

  return null;
};
